import {WindOverLayer} from './wind_map'
import moment from 'moment'
import { WindLayer } from './wind/MapWindLayer'
function drawWind(map, windData, colorScale){
  let drawWindData = []
  for (let i of windData){
    drawWindData.push([i.station_info.Lat,i.station_info.Lng,i.wind_direction,i.wind_speed])
  }
  var windLayer = new WindOverLayer(map,drawWindData,colorScale)
  map.addOverlay(windLayer);

  var options_wind = {
      size: 1.20,
      color: 'rgba(240,240,240,0.8)',
  };

  function finished() {
      windLayer._windy.change(options_wind);
  };

  // var gui = new dat.GUI({
  //     nameMap: {
  //         size: '线条大小',
  //         color: '线条颜色'
  //     }
  // });

  finished();
  // gui.add(options_wind, 'size', 0.1, 10).onFinishChange(finished);
  // gui.addColor(options_wind, 'color').onChange(finished);
  return windLayer
}

function colorAddOpacity(color, opacity) {
  var rgb = color.colorRgb()
  rgb = rgb.split(')') + opacity + ')'
  return rgb
}

function drawWindLayer(map, windData, colorScale, units){
  var windLayer = new WindLayer(map,windData, colorScale, units) 
  windLayer.show()
  return windLayer
}

function drawGridBase(grid, map, ctx, data_type, fill=true, showGridName, zoom, circle,grid_zoom_change,level,opacity, chooseGrid){
  var w=0.009150000000000583/2 
  var j=0.008958443333334287/2
  // if (zoom <= grid_zoom_change){
  //   w=0.02745361/2
  //   j=0.02687533/2
  // }
  w=0.02745361/2
  j=0.02687533/2
  if (level == 1){
    w = w/3
    j = j/3
  }
  if (level == 5){
    w = w/6
    j = j/6
  }

  let lng = grid.lng
  let lat = grid.lat
  let arr = [0, 0, 0, 0, grid.id]
  var lat1=lat+j
  var lat2=lat-j
  var lng1=lng+w
  var lng2=lng-w
  arr[0] = lng1
  arr[2] = lat1
  arr[1] = lng2
  arr[3] = lat2
  var p1=new BMap.Point(lng1,lat2)
  var p2=new BMap.Point(lng1,lat1)
  var p3=new BMap.Point(lng2,lat1)
  var p4=new BMap.Point(lng2,lat2)
  var p5=new BMap.Point(lng,lat)
  var pixel1=map.pointToPixel(p1)
  var pixel2=map.pointToPixel(p2)
  var pixel3=map.pointToPixel(p3)
  var pixel4=map.pointToPixel(p4)
  var center=map.pointToPixel(p5)
  let lineWidth = 2
  // if (grid.name == chooseGrid.name){
  //   lineWidth = 8
  // }
  if (grid.hot_point || level != 3){
    ctx.strokeStyle="red";  
    ctx.lineWidth=lineWidth;  
  }else{
    ctx.strokeStyle="#5f728447";  
    ctx.lineWidth=lineWidth;  
  }
  ctx.beginPath()
  ctx.moveTo(pixel1.x,pixel1.y)
  ctx.lineTo(pixel2.x,pixel2.y)
  ctx.lineTo(pixel3.x,pixel3.y)
  ctx.lineTo(pixel4.x,pixel4.y)
  ctx.closePath()
  ctx.stroke()
  let font_size = (pixel1.y - pixel2.y)/5 + 'px Arial'
  
  
  if (fill == true){
    var bgcolor = '#ff0000'
    var fgcolor = 'black'
    var grid_border = '#5f728447'
    if(grid.childs || level != 3){
      var color=getPMInfo(grid[data_type],data_type)
      bgcolor = color.bgcolor
      fgcolor = color.fgcolor
      if (opacity || opacity==0){
        bgcolor = colorAddOpacity(bgcolor, opacity)
      }
      ctx.fillStyle=bgcolor
      ctx.fill() 
    }
    if (zoom >= 12 &&showGridName && grid.hot_point){
      ctx.fillStyle=fgcolor
      ctx.textAlign = 'center'
      ctx.zIndex = 10
      ctx.font=font_size
      ctx.fillText(grid.name, center.x,center.y)
    }
  }
  
  ctx.beginPath()
  ctx.moveTo(pixel1.x,pixel1.y)
  ctx.lineTo(pixel2.x,pixel2.y)
  ctx.lineTo(pixel3.x,pixel3.y)
  ctx.lineTo(pixel4.x,pixel4.y)
  ctx.closePath()
  ctx.stroke()
  return arr
}

function drawGrid(all_grid_data, map, ctx, data_type, fill=true, showGridName, zoom, circle,grid_zoom_change, opacity, chooseGrid){
  ctx.clearRect(0,0,document.body.clientWidth, document.body.clientHeight)
  let level = 3
  let all_grid = {level1: [], level3: [], level5: []}
  let grid_name_data_set = []
  for (let i in all_grid_data){
    let hot_grid = []
    if (i == 'grid1'){
      level = 1
    }
    if (i == 'grid5'){
      level = 5
    }
    if (i == 'grid3'){
      level = 3
    }
    let grid_data = all_grid_data[i]
    console.log(grid_data)
    if (!grid_data){continue}
    for(let grid of grid_data){
      if (grid.hot_point){
        hot_grid.push(grid)
        continue
      }
      var arr = drawGridBase(grid, map, ctx, data_type, fill, showGridName, zoom, circle,grid_zoom_change, level, opacity, chooseGrid)
      all_grid['level' + level].push(arr)
    }
    for (let g of hot_grid){
      var arr = drawGridBase(g, map, ctx, data_type, fill, showGridName, zoom, circle,grid_zoom_change, level, opacity, chooseGrid) 
      all_grid['level' + level].push(arr)
    }
  }
  let res = [...all_grid.level5, ...all_grid.level1, ...all_grid.level3]
  
  return {all_grid:res, grid_name_data_set: grid_name_data_set}
}


function drawTile(host,map, draw_value, group_id, time, timeType, colormap_dyn_type, p_num_min, min, max,fileName,fileName_flag){
  let type = '1小时'
  time = moment(time).format('YYYY-MM-DD HH')
  if (timeType == 'day'){
    type = '日'
  }
   if (timeType == 'week'){
    type = '周'
    time = moment(time).endOf("week").format('YYYY-MM-DD')
  }
   if (timeType == 'month'){
    type = '当月'
    time = moment(time).endOf("month").format('YYYY-MM-DD')
  }
  if (timeType == 'year') {
    type = '当年'
    time = moment(time).endOf("year").format('YYYY-MM-DD')
  }
  var tileLayer = new BMap.TileLayer();
  tileLayer.getTilesUrl = function(tileCoord, zoom) {
    var x = tileCoord.x;
    var y = tileCoord.y;
    if(fileName_flag){
      var str='9999/file_name/'+fileName+'/bd09?'+'x='+x+'&y='+y+'&z='+zoom
    +'&draw_value='+draw_value+`&p_num_min=${p_num_min}&colormap_dyn_type=` + colormap_dyn_type + '&route_only_point=ALLPOINT&draw_point=1&draw_line=0'
    }else{
      var str=group_id+'/' + type + '/'+time+'/bd09?'+'x='+x+'&y='+y+'&z='+zoom
    +'&draw_value='+draw_value+`&p_num_min=${p_num_min}&colormap_dyn_type=` + colormap_dyn_type + '&route_only_point=ALLPOINT&draw_point=1&draw_line=0'
    }
    var url= ''
    if (process.env.DOCK_ENV) {
      url = `/nuofang-zh-api/api/car_api_py/car_summary_get_api/get_summary_tile/`+str
    } else {
      url = `http://${host}/api/car_api_py/car_summary_get_api/get_summary_tile/`+str
    }
    if (min || max && colormap_dyn_type!='stair'){
      url += `&colormap_min=${min}&colormap_max=${max}`
    }else{
      url += `&colormap_min=0&colormap_max=700`
    }
    return url;
  }.bind(this)
  map.addTileLayer(tileLayer);
  return tileLayer
}

function searchMap(map){
  // 百度地图API功能
  function G(id) {
    return document.getElementById(id);
  }

  var ac = new BMap.Autocomplete(    //建立一个自动完成的对象
    {"input" : "suggestId"
    ,"location" : map
  });

  ac.addEventListener("onhighlight", function(e) {  //鼠标放在下拉列表上的事件
  var str = "";
    var _value = e.fromitem.value;
    var value = "";
    if (e.fromitem.index > -1) {
      value = _value.province +  _value.city +  _value.district +  _value.street +  _value.business;
    }    
    str = "FromItem<br />index = " + e.fromitem.index + "<br />value = " + value;
    
    value = "";
    if (e.toitem.index > -1) {
      _value = e.toitem.value;
      value = _value.province +  _value.city +  _value.district +  _value.street +  _value.business;
    }    
    str += "<br />ToItem<br />index = " + e.toitem.index + "<br />value = " + value;
    G("searchResultPanel").innerHTML = str;
  });

  var myValue;
  ac.addEventListener("onconfirm", function(e) {    //鼠标点击下拉列表后的事件
  var _value = e.item.value;
    myValue = _value.province +  _value.city +  _value.district +  _value.street +  _value.business;
    G("searchResultPanel").innerHTML ="onconfirm<br />index = " + e.item.index + "<br />myValue = " + myValue;
    setPlace(map);
  });

  function setPlace(map){
    // map.clearOverlays();    //清除地图上所有覆盖物
    function myFun(){
      var pp = local.getResults().getPoi(0).point;    //获取第一个智能搜索的结果
      map.centerAndZoom(pp, 18);
      // map.addOverlay(new BMap.Marker(pp));    //添加标注
    }
    var local = new BMap.LocalSearch(map, { //智能搜索
      onSearchComplete: myFun
    });
    local.search(myValue);
  }
}
export {drawWindLayer,drawGrid,searchMap, drawTile}


// WEBPACK FOOTER //
// ./src/utils/ext.js